import axios from 'axios';

const API_URL = process.env.NODE_ENV === 'production'
  ? '/api'
  : (process.env.REACT_APP_API_URL || 'http://localhost:5001/api');

// Axios instance oluştur
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - her isteğe token ekle
api.interceptors.request.use(
  (config: any) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error: any) => Promise.reject(error)
);

// Response interceptor - token süresi dolmuşsa yönlendir
api.interceptors.response.use(
  (response: any) => response,
  (error: any) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Auth API
export const authAPI = {
  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),

  verify: () => api.get('/auth/verify'),

  profile: () => api.get('/auth/profile'),
};

// People API
export const peopleAPI = {
  getAll: () => api.get('/people'),

  getById: (id: number) => api.get(`/people/${id}`),

  create: (data: any) => api.post('/people', data),

  update: (id: number, data: any) => api.put(`/people/${id}`, data),

  delete: (id: number) => api.delete(`/people/${id}`),

  getStats: (id: number) => api.get(`/people/${id}/stats`),
};

// Videos API
export const videosAPI = {
  getAll: () => api.get('/videos'),

  getById: (id: number) => api.get(`/videos/${id}`),

  getBySlug: (slug: string) => api.get(`/videos/slug/${slug}`),

  create: (data: any) => api.post('/videos', data),

  update: (id: number, data: any) => api.put(`/videos/${id}`, data),

  delete: (id: number) => api.delete(`/videos/${id}`),

  getStats: (id: number) => api.get(`/videos/${id}/stats`),

  upload: (formData: FormData, onProgress?: (progress: number) => void) => api.post('/upload/video', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        onProgress(percentCompleted);
      }
    },
  }),

  getStatus: (slug: string) => api.get(`/upload/status/${slug}`),
};

// Links API
export const linksAPI = {
  create: (data: any) => api.post('/links', data),

  verify: (token: string) => api.get(`/links/verify/${token}`),

  getAll: () => api.get('/links'),

  getPersonLinks: (personId: number) => api.get(`/links/person/${personId}`),

  getVideoLinks: (videoId: number) => api.get(`/links/video/${videoId}`),

  delete: (id: number) => api.delete(`/links/${id}`),

  getStats: (id: number) => api.get(`/links/${id}/stats`),
};

export const reportsAPI = {
  getSummary: () => api.get('/logs/summary'),
};

// Logs API
export const logsAPI = {
  create: (data: any) => api.post('/logs', data),

  getByLink: (linkId: number) => api.get(`/logs/link/${linkId}`),

  getByPerson: (personId: number) => api.get(`/logs/person/${personId}`),

  getByVideo: (videoId: number) => api.get(`/logs/video/${videoId}`),

  getAll: (params: any) => api.get('/logs', { params }),

  getSharingAnalysis: (linkId: number) => api.get(`/logs/sharing/${linkId}`),
};

export default api;